import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLocalized } from "@/hooks/useLocalized";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Users } from "lucide-react";

const PackageCards = ({ packages, loading, activeTab, l, lArr }) => {
  const { t } = useTranslation();

  if (loading) {
    return (
      <div className="flex justify-center py-20">
        <div className="spinner"></div>
      </div>
    );
  }

  const filteredPackages =
    activeTab === "all"
      ? packages
      : packages.filter((pkg) => pkg.package_type === activeTab);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
      {filteredPackages.map((pkg, idx) => (
        <Card
          key={pkg.id}
          className="bg-white border-0 shadow-lg overflow-hidden card-lift"
          data-testid={`package-card-${idx}`}
        >
          <div className="flex flex-col md:flex-row">
            <div className="md:w-2/5 h-64 md:h-auto img-hover-zoom">
              <img
                src={pkg.image_url || "https://images.unsplash.com/photo-1665332195309-9d75071138f0?w=600"}
                alt={pkg.name}
                className="w-full h-full object-cover"
              />
            </div>
            <CardContent className="md:w-3/5 p-6 md:p-8 flex flex-col justify-between">
              <div>
                <Badge className="bg-[#2D6A4F]/10 text-[#2D6A4F] hover:bg-[#2D6A4F]/20 mb-3">
                  {pkg.package_type}
                </Badge>
                <h3 className="text-2xl font-bold text-[#3D405B] mb-2 font-['Playfair_Display']">
                  {l(pkg, "name")}
                </h3>
                <p className="text-[#6B705C] text-sm mb-4">{l(pkg, "description")}</p>
                <div className="flex items-center gap-4 text-sm text-[#6B705C] mb-4">
                  <span className="flex items-center gap-1">
                    <Users className="w-4 h-4" />
                    {pkg.min_guests}-{pkg.max_guests} {t("menu.guests")}
                  </span>
                </div>
                <div className="mb-4">
                  <p className="text-sm font-medium text-[#3D405B] mb-2">{t("menu.includes")}</p>
                  <div className="flex flex-wrap gap-2">
                    {lArr(pkg, "includes").slice(0, 4).map((item) => (
                      <span key={`${pkg.id}-${item}`} className="text-xs bg-[#F2CC8F]/30 text-[#3D405B] px-2 py-1 rounded-full">
                        {item}
                      </span>
                    ))}
                    {lArr(pkg, "includes").length > 4 && (
                      <span className="text-xs text-[#6B705C]">
                        {t("menu.more", { count: lArr(pkg, "includes").length - 4 })}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <div className="flex items-end justify-end mt-4 pt-4 border-t border-gray-100">
                <Link to="/booking">
                  <Button
                    className="bg-[#E07A5F] hover:bg-[#D0694E] text-white rounded-full"
                    data-testid={`book-package-btn-${idx}`}
                  >
                    {t("menu.selectPackage")}
                  </Button>
                </Link>
              </div>
            </CardContent>
          </div>
        </Card>
      ))}
    </div>
  );
};

export default PackageCards;
